import { useField } from 'formik';
import { useEffect, useState } from 'react';

import { MPSlider } from '../Slider/Slider';

import type { MPSliderProps } from '../Slider/Slider';
import type { ReactElement } from 'react';

type Props = { name: string } & Omit<MPSliderProps, 'handleChange' | 'value' | 'description'>;

const getDescription = (from: string, to: string): string => `$${from} to $${to} a day`;

const SliderField = ({ name, ...rest }: Props): ReactElement => {
  const [{ value }, { initialValue }, { setValue }] = useField(name);
  const [description, setDescription] = useState<string>(
    getDescription(initialValue[0], initialValue[1])
  );

  const handleChange = (_e: Event, newValue: number | number[]): void => {
    setValue(newValue);
  };

  useEffect(() => {
    setDescription(getDescription(value[0], value[1]));
  }, [value]);

  return (
    <MPSlider
      description={description}
      handleChange={handleChange}
      // value as integer required by MUI slider component
      value={[parseInt(value[0]), parseInt(value[1])]}
      {...rest}
    />
  );
};

export { SliderField };
